// Pile de navigation propre à l'app, plus fiable que window.history dans une
// WebView Capacitor. Permet au BackButton de retrouver la vraie page
// précédente en sautant les pages transitoires (édition/modification).

const MAX_ENTRIES = 50;
let stack: string[] = [];

// Pages d'édition/modification : jamais une destination utile pour "retour",
// on continue de remonter la pile jusqu'à une page "normale".
const TRANSIENT_PATTERN = /^\/(edit[a-z-]*|modmatch|creatematch|createnews|createtraining|addplayer|addpodcast)(\/|\?|$)/i;

export function isTransientPath(path: string): boolean {
  return TRANSIENT_PATTERN.test(path);
}

export function pushHistoryEntry(path: string) {
  if (stack[stack.length - 1] === path) return; // évite les doublons consécutifs
  stack.push(path);
  if (stack.length > MAX_ENTRIES) stack = stack.slice(-MAX_ENTRIES);
}

// Retourne la page précédente "utile" (non transitoire), ou null si la pile
// est épuisée (l'appelant doit alors utiliser son fallback).
export function getSmartBackTarget(): string | null {
  let i = stack.length - 2; // -1 = page courante
  while (i >= 0 && isTransientPath(stack[i])) i--;
  return i >= 0 ? stack[i] : null;
}
